var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconWithNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 2.63281H18.2422C19.0733 2.63281 19.75 3.30956 19.75 4.14062C19.75 4.97205 19.0733 5.64844 18.2422 5.64844H6.44531C5.61385 5.64844 4.9375 4.97208 4.9375 4.14062C4.9375 3.30952 5.61389 2.63281 6.44531 2.63281Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 8.49219H18.2422C19.0733 8.49219 19.75 9.16893 19.75 10C19.75 10.8314 19.0733 11.5078 18.2422 11.5078H6.44531C5.61385 11.5078 4.9375 10.8315 4.9375 10C4.9375 9.16889 5.61389 8.49219 6.44531 8.49219Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44531 14.3516H18.2422C19.0733 14.3516 19.75 15.0283 19.75 15.8594C19.75 16.6908 19.0733 17.3672 18.2422 17.3672H6.44531C5.61385 17.3672 4.9375 16.6908 4.9375 15.8594C4.9375 15.0283 5.61389 14.3516 6.44531 14.3516Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75781 2.38281C0.788281 2.38281 0 3.17148 0 4.14062C0 5.11016 0.788281 5.89844 1.75781 5.89844C2.72695 5.89844 3.51562 5.11016 3.51562 4.14062C3.51562 3.17148 2.72695 2.38281 1.75781 2.38281Z",
    fill: "#4F4F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75781 8.24219C0.788281 8.24219 0 9.03086 0 10C0 10.9695 0.788281 11.7578 1.75781 11.7578C2.72695 11.7578 3.51562 10.9695 3.51562 10C3.51562 9.03086 2.72695 8.24219 1.75781 8.24219Z",
    fill: "#4F4F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75781 14.1016C0.788281 14.1016 0 14.8902 0 15.8594C0 16.8289 0.788281 17.6172 1.75781 17.6172C2.72695 17.6172 3.51562 16.8289 3.51562 15.8594C3.51562 14.8902 2.72695 14.1016 1.75781 14.1016Z",
    fill: "#4F4F4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6C18.6569 6 20 4.65685 20 3C20 1.34315 18.6569 0 17 0C15.3431 0 14 1.34315 14 3C14 4.65685 15.3431 6 17 6Z",
    fill: "#F00D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconWithNotification);
export default __webpack_public_path__ + "static/media/menu-icon-with-notification.c883479126cee39cf0e000f301f1634b.svg";
export { ForwardRef as ReactComponent };